import { Box, CircularProgress, Typography } from '@mui/material';

interface Props {
  label?: string;
  dense?: boolean;
  /** Full-viewport centered loader (used for route/auth gating). */
  fullScreen?: boolean;
}

/** Consistent loading indicator. */
export function LoadingState({ label = 'Loading…', dense, fullScreen }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        color: 'text.secondary',
        py: dense ? 3 : 6,
        minHeight: fullScreen ? '100vh' : undefined,
      }}
    >
      <CircularProgress size={dense ? 24 : 34} thickness={4} />
      {label && <Typography variant="body2">{label}</Typography>}
    </Box>
  );
}
